import {Button, styled} from "@mui/material";

// State button
export const StateButton = styled(Button)(({theme}) => ({
    color: theme.barekam.sidebar.textDark,
    padding: '1.5rem',
    width: '100%',
    gap: '0.5rem',
    borderBottom: '1px solid #F1F1FB',
    borderRadius: '0px',
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',

    '&:hover': {
        backgroundColor: theme.barekam.sidebar.filterButton.hover,
    }
}));

export const StateButtonSelected = styled(StateButton)(({theme}) => ({
    background: theme.barekam.sidebar.filterButton.selected,
    color: theme.barekam.sidebar.textLight,
    fontWeight: 'bold',

    '&:hover': {
        backgroundColor: theme.barekam.sidebar.filterButton.hoverSelected
    },

    '& img': {
        filter: 'brightness(1000%) saturate(0%) contrast(1000%)'
    }
}))

export const DashboardButton = styled(StateButton)(({theme}) => ({
    color: theme.barekam.sidebar.textDark,
    backgroundColor: theme.barekam.sidebar.dashboardButton.background,

    '&:hover': {
        backgroundColor: theme.barekam.sidebar.dashboardButton.hover,
    },

    '& img': {
        filter: 'brightness(0%) saturate(0%) contrast(-1000%)'
    }
}));

// Type button
export const TabButton = styled(Button)(({theme}) => ({
    color: theme.barekam.sidebar.textDark,
    padding: '44px 18px 44px 44px',

    height: '5.125rem',
    width: '20rem',
    borderRadius: '0px',
    alignItems: 'center',
    display: 'inline-flex',
    justifyContent: 'space-between',

    '&:hover': {
        backgroundColor: theme.barekam.sidebar.filterButton.hover
    },
    '& img': {
        filter: 'brightness(0%) saturate(0%) contrast(0%)'
    }
}));

export const TabButtonSelected = styled(StateButton)(({theme}) => ({
    background: theme.barekam.sidebar.filterButton.selected,
    color: theme.barekam.sidebar.textLight,
    fontWeight: 'bold',
    padding: '44px 18px 44px 44px',

    '&:hover': {
        backgroundColor: theme.barekam.sidebar.filterButton.hoverSelected
    },
    '& img': {
        filter: 'brightness(1000%) saturate(0%) contrast(1000%)'
    }
}))
